export const showPriceLists = (state) => state.priceLists
